<template>
  <div class="legend-container">
    <div class="legend-child" v-for="(item,index) in legendData" v-bind:key="index">
      <div class="dot" v-bind:style="{'background': item.color}"></div>
      <span class="label">{{item.label}}</span>
      <span class="percentage">{{item.percentage.toFixed(2)}} %</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable arrow-body-style */
import _ from 'lodash';
import numberUtils from '@/utils/numberUtils';

export default {
  mixins: [numberUtils],
  props: ['labels', 'colors', 'percentage'],
  data() {
    return {
      legendData: [],
    };
  },
  watch: {
    labels() {
      this.mapData();
    },
  },
  created() {
    this.mapData();
  },
  methods: {
    mapData() {
      const legend = _.map(this.labels, (data, index) => {
        return {
          percentage: this.percentage[index],
          label: this.labels[index],
          color: this.colors[index],
        };
      });
      this.legendData = _.cloneDeep(legend);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.legend-container {
  height: 100%;
  display: flex;
  justify-content: center;
  align-self: center;
  flex-direction: column;
  .legend-child {
    display: flex;
    .dot {
      border-radius: 50%;
      width: $spacer / 1.5;
      height: $spacer / 1.5;
      justify-content: flex-start;
      align-self: center;
      min-width: $spacer / 1.5;
    }
    .label {
      color: $gray-600;
      margin: 0 $spacer / 2;
      font-size: $font-size-base / 1.5;
      text-overflow: ellipsis;
      line-height: 1.5em;
      max-height: 1.5em;
      overflow: hidden;
    }
    .percentage {
      color: $gray-700;
      justify-content: flex-end;
      margin-left: auto;
      text-align: right;
      min-width: 40px;
      font-size: $font-size-base / 1.5;
    }
  }
}
</style>
